import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _mutations;
import { SELECT_ADDRESS, FORM_INFO } from '@/constants/address';
export default {
  namespaced: true,
  state: {
    selectInfo: {},
    // 所选地址信息
    formInfo: {} // 表单信息
  },

  mutations: (_mutations = {}, _defineProperty(_mutations, SELECT_ADDRESS, function (state, payload) {
    state.selectInfo = payload;
  }), _defineProperty(_mutations, FORM_INFO, function (state, payload) {
    state.formInfo = payload;
  }), _mutations),
  actions: {},
  getters: {
    selectInfo: function selectInfo(state) {
      return state.selectInfo;
    },
    formInfo: function formInfo(state) {
      return state.formInfo;
    }
  }
};